<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <div>
      <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Tableau de bord Expert-Comptable 📊</h1>
      <p class="text-gray-500 mt-1">Vue d'ensemble de vos {{ companies().length }} client{{ companies().length !== 1 ? 's' : '' }}</p>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-5 gap-4">
      <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">groups</span>
          </div>
          <div>
            <div class="text-2xl font-display font-bold text-gray-900">{{ companies().length }}</div>
            <div class="text-xs text-gray-500">Clients</div>
          </div>
        </div>
      </article>
      <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">calculate</span>
          </div>
          <div>
            <div class="text-2xl font-display font-bold text-gray-900">{{ cfeOkCount() }}/{{ companies().length }}</div>
            <div class="text-xs text-gray-500">CFE à jour</div>
          </div>
        </div>
      </article>
      <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">account_balance</span>
          </div>
          <div>
            <div class="text-2xl font-display font-bold text-gray-900">{{ taxeFonciereOkCount() }}/{{ companies().length }}</div>
            <div class="text-xs text-gray-500">Taxes foncières</div>
          </div>
        </div>
      </article>
      <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">receipt_long</span>
          </div>
          <div>
            <div class="text-2xl font-display font-bold text-gray-900">{{ tvaOkCount() }}/{{ companies().length }}</div>
            <div class="text-xs text-gray-500">TVA à jour</div>
          </div>
        </div>
      </article>
      <article class="rounded-xl bg-white border border-gray-200 p-5 shadow-card">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">description</span>
          </div>
          <div>
            <div class="text-2xl font-display font-bold text-gray-900">{{ impotSocieteOkCount() }}/{{ companies().length }}</div>
            <div class="text-xs text-gray-500">IS à jour</div>
          </div>
        </div>
      </article>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <button type="button" class="rounded-2xl border border-gray-200 bg-white py-4 px-4 flex flex-col items-center gap-2 hover:bg-gray-50 cursor-pointer" (click)="openClients()">
        <span class="material-symbols-outlined text-secondary">groups</span>
        <span class="text-sm font-medium">Gérer mes clients</span>
        <span class="text-xs text-gray-500">Import CSV, ajout SIREN</span>
      </button>
      <!-- Portail d'échange (désactivé)
      <button type="button" class="rounded-2xl border border-gray-200 bg-white py-4 px-4 flex flex-col items-center gap-2 hover:bg-gray-50 cursor-pointer" (click)="openPortal()">
        <span class="material-symbols-outlined text-secondary">swap_horiz</span>
        <span class="text-sm font-medium">Portail d'échange</span>
        <span class="text-xs text-gray-500">Documents & messages</span>
      </button>
      -->
      <button type="button" class="rounded-2xl border border-gray-200 bg-white py-4 px-4 flex flex-col items-center gap-2 hover:bg-gray-50 cursor-pointer" (click)="openDocuments()">
        <span class="material-symbols-outlined text-secondary">description</span>
        <span class="text-sm font-medium">Documents</span>
        <span class="text-xs text-gray-500">Export groupé</span>
      </button>
    </div>

    <div class="rounded-2xl bg-white border border-gray-200 shadow-card overflow-hidden">
      <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-secondary">calculate</span>
          </div>
          <div>
            <h2 class="font-display text-lg font-semibold text-gray-900">Suivi fiscal par client</h2>
            <p class="text-xs text-gray-500">CFE · Taxes foncières · TVA · IS</p>
          </div>
        </div>
        <button type="button" class="text-sm text-secondary hover:underline cursor-pointer" (click)="openCertifications()">Voir tout</button>
      </div>

      @if (loading()) {
        <div class="p-8 text-center text-sm text-gray-500">Chargement...</div>
      } @else if (!clientStatuses().length) {
        <div class="p-8 text-center">
          <span class="material-symbols-outlined text-gray-400 text-4xl">groups</span>
          <p class="text-sm text-gray-500 mt-2">Ajoutez des clients pour suivre leur situation fiscale</p>
          <button type="button" class="mt-3 rounded-md bg-secondary text-white px-3 py-2 text-sm cursor-pointer" (click)="openClients()">Ajouter des clients</button>
        </div>
      } @else {
        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr class="border-b border-gray-200 bg-gray-50">
                <th class="text-left px-5 py-3 font-medium text-gray-500">Client</th>
                <th class="text-left px-3 py-3 font-medium text-gray-500">SIREN</th>
                <th class="text-center px-3 py-3 font-medium text-gray-500">Avis CFE</th>
                <th class="text-center px-3 py-3 font-medium text-gray-500">Taxe foncière</th>
                <th class="text-center px-3 py-3 font-medium text-gray-500">TVA</th>
                <th class="text-center px-3 py-3 font-medium text-gray-500">IS</th>
                <th class="text-center px-3 py-3 font-medium text-gray-500">Documents</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              @for (client of visibleClientStatuses(); track client.siren) {
                <tr class="hover:bg-gray-50 transition-colors">
                  <td class="px-5 py-3 font-medium text-gray-900">{{ client.name }}</td>
                  <td class="px-3 py-3 text-gray-500 font-mono text-xs">{{ client.siren }}</td>
                  <td class="px-3 py-3 text-center"><span class="text-[10px] border rounded px-2 py-0.5" [class]="statusClass(client.cfe)">{{ statusLabel(client.cfe) }}</span></td>
                  <td class="px-3 py-3 text-center"><span class="text-[10px] border rounded px-2 py-0.5" [class]="statusClass(client.taxeFonciere)">{{ statusLabel(client.taxeFonciere) }}</span></td>
                  <td class="px-3 py-3 text-center"><span class="text-[10px] border rounded px-2 py-0.5" [class]="statusClass(client.tva)">{{ statusLabel(client.tva) }}</span></td>
                  <td class="px-3 py-3 text-center"><span class="text-[10px] border rounded px-2 py-0.5" [class]="statusClass(client.impotSociete)">{{ statusLabel(client.impotSociete) }}</span></td>
                  <td class="px-3 py-3 text-center">
                    <button type="button" class="text-xs text-secondary hover:underline cursor-pointer" (click)="openCertifications()">Détail</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (clientStatuses().length > 10) {
            <div class="px-5 py-3 text-center border-t border-gray-200">
              <button type="button" class="text-sm text-secondary hover:underline cursor-pointer" (click)="openClients()">
                Voir les {{ clientStatuses().length - 10 }} autres clients
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="grid sm:grid-cols-2 gap-4">
      <button type="button" class="rounded-xl border border-gray-200 bg-white p-5 text-left hover:bg-gray-50 cursor-pointer" (click)="openNotifications()">
        <span class="material-symbols-outlined text-secondary">notifications</span>
        <h2 class="font-semibold text-gray-900">Notifications</h2>
        <p class="text-sm text-gray-500 mt-1">Suivez les alertes sur l'ensemble de vos clients.</p>
      </button>
      <button type="button" class="rounded-xl border border-gray-200 bg-white p-5 text-left hover:bg-gray-50 cursor-pointer" (click)="openSettings()">
        <span class="material-symbols-outlined text-secondary">settings</span>
        <h2 class="font-semibold text-gray-900">Paramètres</h2>
        <p class="text-sm text-gray-500 mt-1">Gérez vos préférences et votre sécurité.</p>
      </button>
    </div>
  </div>
</section>
